import * as types from '../types/loginTypes'
import * as axios from 'axios'
import { isEmpty } from 'lodash'

export const signInUser = (user) => {
    return {
        type: types.AUTH_SIGNIN_USER,
        user,
    }
}

export const signInFetchUsers = (username, password) => {
    return (dispatch) => {
        return axios
            .post(`${process.env.REACT_APP_LOGIN_ENDPOINT}`, { username, password })
            .then((res) => {
                if (!isEmpty(res.data.resultSet)) {
                    dispatch(signInUser(res.data.resultSet));
                    return new Promise(function (resolve) {
                        resolve(res.data.resultSet);
                    })
                }
            })
            .catch((error) => {
                return error
            })
    }
}
export function autoLogin(token, userKey) {
    return (dispatch) => {
        return axios
            .post(`${process.env.REACT_APP_AUTO_LOGIN}`, { token, userKey })
            .then((res) => {
                if (!isEmpty(res.data.resultSet)) {
                    dispatch(signInUser(res.data.resultSet));
                    return new Promise(function (resolve) {
                        resolve(res.data.resultSet);
                    });
                }
            })
            .catch((err) => {
                return err;
            });
    };
}

export const authLogoutUser = (user) => {
    return {
        type: types.AUTH_LOGOUT_USER,
        user
    };
};

export function logout() {
    return (dispatch) => {
        dispatch(authLogoutUser([]));
    };
}
export const authTokenLogout = (user) => {
    return {
        type: types.AUTH_TOKEN_LOGOUT_USER,
        user
    };
};

export function tokenLogout() {
    return (dispatch) => {
        dispatch(authTokenLogout([]));
    };
}